import { useRouteLoaderData } from 'react-router';
import type { loader as rootLoader } from '~/root';

/**
 * Provides typed data from the loader in root.tsx.
 */
export const useRootLoaderData = () => {
  const data = useRouteLoaderData<typeof rootLoader>('root');

  if (!data) {
    throw new Error('Unable to retrieve root loader data');
  }

  return data;
};
